import { injectGlobal } from "styled-components"
import { Colors } from "../lib/theme"

injectGlobal`
  .ant-steps-item.ant-steps-item-process .ant-steps-item-icon {
    // background-color: ${Colors.backgroundDarkBlue};
    background-color:#535353;
    // border-color: ${Colors.backgroundDarkBlue};
    border-color:#535353;
  }

  .ant-steps-item-finish .ant-steps-item-tail:after {
    // background-color: ${Colors.backgroundDarkBlue};
    background-color: #535353;
  }
  
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: ${Colors.backgroundDarkBlue};
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    // color: ${Colors.backgroundDarkBlue};
    color: #535353;
  }
  .ant-radio-button-wrapper:hover, .ant-radio-button-wrapper-focused {
    color: ${Colors.backgroundDarkBlue};      
  }

  .ant-btn-primary, .ant-btn-primary:hover {
    background-color: ${Colors.backgroundDarkBlue};
    border-color: ${Colors.backgroundDarkBlue};
  }

  .ant-radio-group-large .ant-radio-button-wrapper {
    display:flex;
    min-height: 49px;
    background-color:white;
    height: auto;
    span {
      margin-top:auto;
      margin-bottom:auto;
    }
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    border-color:#535353;
  }
  .ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
    // border-color:  ${Colors.backgroundDarkBlue};
    // color: ${Colors.backgroundDarkBlue};
    border-color:  #535353;
    background-color: #535353;
    color: white;
  }
  select,
  .ant-input-lg,
  .ant-select-selection {
    height:49px;
    color:#535353;
    border-color:#535353;
    &::placeholder {
      color:#535353;
    }
    &:focus {
      outline:none;
    }
  }
  .ant-select-arrow:before {
    width:16px;
    height:8px;
    font-size:16px;
    color:#535353;
  }
  .ant-select-lg .ant-select-selection--single {
    height:49px;
  }
  .ant-select-selection__rendered {
    margin-top:auto;
    margin-bottom:auto;
  }
  .ant-select-lg .ant-select-selection__rendered {
    line-height:49px;
  }
  .ant-input-number-lg input {
    height:48px;
  }
  .ant-input-number-lg {
    height:50px;
  }

  .ant-btn-group-lg > .ant-btn {
    font-size:18px;
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    line-height:20px;
    align-items:center;
    min-width:223px;
    min-height:65px;
    height:65px;
    font-weight:500;
    text-transform:uppercase;
    font-family:adobe-garamond-pro;
  }

  .ant-input-number {
    border-color:#535353;
    box-shadow:none;
  }

  input,
  input:focus,
  input:hover,
  .ant-input-number:focus,
  .ant-input-number:hover,
  .ant-select-selection:hover,
  .ant-select-selection:focus,
  .ant-input:focus,
  .ant-input:hover,
  select:focus,
  select:hover {
    outline:none;
    box-shadow:none;
    border-color:${Colors.actionPrimary};
  }
  body {
    min-height:100%
    background-image: linear-gradient(#FFFFFF, #F6F6F6);
    overflow-y:auto;
  }
  a {
    color:#F7B44E;
  }
  ::selection {
    background-color:${Colors.actionPrimary};
  }
  button:focus {
    background-color:${Colors.actionPrimary} !important;
  }
  html,
  body,
  #root,
  #root main {
    width:100%;
  }
`



// WEBPACK FOOTER //
// ./src/utils/overwrite-ant-styles.js